/**
 * ENS names under zeuscc8.eth: what a name may contain, what it costs and the text a wallet
 * signs to prove it owns one. No network, no wallet, no React.
 */

export const PARENT_ENS = 'zeuscc8.eth';

export type Tier = 'free' | 'standard' | 'premium';

export const TIERS: Array<{ tier: Tier; label: string; usd: number }> = [
  { tier: 'free', label: '10 or more characters', usd: 0 },
  { tier: 'standard', label: '4 to 9 characters', usd: 50 },
  { tier: 'premium', label: '1 to 3 characters', usd: 200 },
];

/** Used when the ETH price cannot be read. */
export const FALLBACK_ETH_USD = 3000;

export const sanitizeLabel = (value: string): string => value.toLowerCase().replace(/[^a-z0-9-]/g, '');

export const tierOf = (label: string): Tier | null => {
  if (!label) return null;
  if (label.length >= 10) return 'free';
  if (label.length >= 4) return 'standard';
  return 'premium';
};

export const priceOf = (label: string, ethUsd: number): { tier: Tier | null; usd: number; eth: number } => {
  const tier = tierOf(label);
  const usd = tier ? TIERS.find((t) => t.tier === tier)!.usd : 0;
  const rate = ethUsd > 0 ? ethUsd : FALLBACK_ETH_USD;
  return { tier, usd, eth: usd === 0 ? 0 : usd / rate };
};

export const fullName = (label: string): string => `${label}.${PARENT_ENS}`;

export const isAddress = (value: string): boolean => /^0x[a-fA-F0-9]{40}$/.test(value);

export const shortAddress = (address: string): string => `${address.slice(0, 6)}...${address.slice(-4)}`;

/** Must stay identical to api/_lib/ensAuth.js, which rebuilds it to check the signature. */
export const ensMessage = ({ action, name, value, issuedAt }: { action: string; name: string; value: string; issuedAt: string }): string =>
  ['pepes.dog ENS', `Action: ${action}`, `Name: ${name}`, `Value: ${value}`, `Issued: ${issuedAt}`].join('\n');
